import 'bootstrap';
import { Aurelia } from 'aurelia-framework';
import environment from '../config/environment.json';
import { PLATFORM } from 'aurelia-pal';
import { I18N, Backend, TCustomAttribute } from 'aurelia-i18n';
import { AppRouter } from 'aurelia-router';
import { fs } from './Config/FsConfig';
import OidcConfig from './Config/open-id-connect-configuration';

export async function configure(aurelia: Aurelia) {
  aurelia.use.standardConfiguration();
  await fs.InitConfig();
  await OidcConfig.InitConfig();

  if (environment.testing) {
    aurelia.use.plugin(PLATFORM.moduleName('aurelia-testing'));
  }

  aurelia.use.plugin(PLATFORM.moduleName('aurelia-dialog'));
  aurelia.use.plugin(PLATFORM.moduleName('aurelia-toolbelt/components/bootstrap/navbar'));
  aurelia.use.plugin(PLATFORM.moduleName('aurelia-validation'));
  aurelia.use.plugin(PLATFORM.moduleName('aurelia-open-id-connect'), () => OidcConfig.Config);
  aurelia.use.plugin(PLATFORM.moduleName('aurelia-bootstrap-datetimepicker'), config => {
    config.extra.bootstrapVersion = 4;
  });
  aurelia.use.plugin(PLATFORM.moduleName('aurelia-i18n'), (instance) => {

    let aliases = ['t', 'i18n'];
    // add aliases for 't' attribute
    TCustomAttribute.configureAliases(aliases);

    // register backend plugin
    instance.i18next.use(Backend.with(aurelia.loader));//.use(modules[3]);

    // adapt options to your needs (see http://i18next.com/docs/options/)
    // make sure to return the promise of the setup method, in order to guarantee proper loading

    instance.setup({
      backend: {
        loadPath: loadPath
      },
      attributes: aliases,
      fallbackLng: 'th',
      debug: true
    }).then(() => {
    });
  });

  aurelia.use.feature(PLATFORM.moduleName('Modules/Sample/index'));
  aurelia.use.feature(PLATFORM.moduleName('Modules/Core/index'));
  aurelia.use.feature(PLATFORM.moduleName('Modules/Aqs/index'));

  //Uncomment the line below to enable animation.
  // aurelia.use.plugin(PLATFORM.moduleName('aurelia-animator-css'));
  //if the css animator is enabled, add swap-order="after" to all router-view elements

  //Anyone wanting to use HTMLImports to load views, will need to install the following plugin.
  // aurelia.use.plugin(PLATFORM.moduleName('aurelia-html-import-template-loader'));

  aurelia.start().then(() => aurelia.setRoot(PLATFORM.moduleName('app')));
}

function loadPath(lng, namespace) {

  console.log("Namespace: " + namespace[0]);
  var splitPath = namespace[0].split(".");
  let path = "";
  if (splitPath.length > 1) {
    path = 'Modules/' + splitPath[0] + '/Locales/' + lng + '/' + splitPath[1] + '.json';
  } else {
    path = 'Modules/Core/Locales/' + lng + '/' + splitPath[0] + '.json';
  }
  return path;
}
